import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'reportInFolderFilter',
    pure: false
})
export class ReportInFolderFilter implements PipeTransform {

    transform(reports, reportSearch): any {
        if (reports != null) {
            return reports.filter(

                report =>
                    reportSearch == undefined || reportSearch == 'All' || report.ReportFolder == reportSearch
            );

        }
        // console.log('reportsFilter class');
    }




    // code from angular js
    //         return function (reports, folder) {
    //             var filteredReports = [];
    //             if (reports != null) {
    //                 reports.forEach(function (report) {
    //                     if (folder == null || _.findWhere(folder.Reports, { Id: report.Id }) != null) {
    //                         if (_.findWhere(filteredReports, { Id: report.Id }) == null)
    //                             filteredReports.push(report);
    //                     }
    //                 })
    //     }
    //     return filteredReports;
    //  }

}
